import styled from "styled-components";

const StyledSnapper = styled.div`
  box-sizing: border-box;
  transition: all ease-in-out 100ms;
  background: #4e4e4e;
  border: solid 1px #777;
  &:hover {
    background: #4cc2ff;
    border: solid 1px #4cc2ff;
  }
`;

export default StyledSnapper;
